import { render, staticRenderFns } from "./ExternalSeriesChip.vue?vue&type=template&id=ed449b9a&"
import script from "./ExternalSeriesChip.vue?vue&type=script&lang=js&"
export * from "./ExternalSeriesChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports